import { render, staticRenderFns } from "./CartaoInformacoesServicos.vue?vue&type=template&id=074758e0&scoped=true"
import script from "./CartaoInformacoesServicos.vue?vue&type=script&lang=js"
export * from "./CartaoInformacoesServicos.vue?vue&type=script&lang=js"
import style0 from "./CartaoInformacoesServicos.vue?vue&type=style&index=0&id=074758e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074758e0",
  null
  
)

export default component.exports